import { useParams } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { RowSkeleton } from "@/shared/components/ui/RowSkeleton";
import { CalendarEventForm } from "../components/CalendarEventForm";
import { useCalendarEvent } from "../hooks/calendarEventQueries";
import type { CalendarEventKind } from "../types/calendarEventTypes";

export function CalendarEventEditPage({ kind }: { kind?: CalendarEventKind }) {
  const { eventId = "" } = useParams();
  const { business, businessId, loading } = useCurrentBusiness();
  const { user } = useAuth();
  const query = useCalendarEvent(eventId);
  if (!business || loading || (!kind && (query.isLoading || query.error || !query.data))) {
    return <Page><PageHeader title={kind ? "New event" : "Edit event"} /><PageContent>
      {query.error ? <ErrorState message={query.error.message} onRetry={() => void query.refetch()} />
        : loading || query.isLoading ? <RowSkeleton /> : <EmptyState message="Event or business unavailable." />}
    </PageContent></Page>;
  }
  return <CalendarEventForm key={`${user?.id}:${businessId}:${eventId}:${kind}`} kind={kind ?? query.data!.kind} event={kind ? undefined : query.data} />;
}
